import api from '@/api/clients/api';
import { BillingGroup } from '@/features/billing-groups/api/types/billing-group';
import { DiscountHistory } from '@/features/hosts/api/types/discount';
import { Host } from '@/features/hosts/api/types/host';
import { PaginatedResponse } from '@/types/responses/paginated-response';

class BillingGroupApi {
  async fetchBillingGroups(
    page: number,
    perPage: number,
    query?: string,
  ): Promise<PaginatedResponse<BillingGroup>> {
    const { data } = await api.get<PaginatedResponse<BillingGroup>>(`/billing-groups`, {
      params: {
        page,
        perPage,
        search: query,
      },
    });

    return data;
  }

  async fetchBillingGroup(billingGroupId: number): Promise<BillingGroup> {
    const { data } = await api.get<BillingGroup>(`/billing-groups/${billingGroupId}`);

    return data;
  }

  async createBillingGroup(name: string, discountTemplatesIds: number[]): Promise<BillingGroup> {
    const { data } = await api.post<BillingGroup>(`/billing-groups`, {
      name,
      discountTemplatesIds,
    });

    return data;
  }

  async updateBillingGroup(
    billingGroupId: number,
    name: string,
    discountTemplatesIds: number[],
  ): Promise<BillingGroup> {
    const { data } = await api.put<BillingGroup>(`/billing-groups/${billingGroupId}`, {
      name,
      discountTemplatesIds,
    });

    return data;
  }

  async removeBillingGroup(billingGroupId: number): Promise<BillingGroup> {
    const { data } = await api.delete<BillingGroup>(`/billing-groups/${billingGroupId}`);

    return data;
  }

  async fetchDiscountHistory(
    billingGroupId: number,
    page: number,
    perPage: number,
  ): Promise<PaginatedResponse<DiscountHistory>> {
    const { data } = await api.get<PaginatedResponse<DiscountHistory>>(
      `/billing-groups/${billingGroupId}/discount-history`,
      {
        params: {
          page,
          perPage,
        },
      },
    );

    return data;
  }

  async addHostToBillingGroup(billingGroupId: number, hostId: number): Promise<Host> {
    const { data } = await api.post<Host>(`/billing-groups/${billingGroupId}/hosts/${hostId}`);

    return data;
  }

  async removeHostFromBillingGroup(billingGroupId: number, hostId: number): Promise<Host> {
    const { data } = await api.delete<Host>(`/billing-groups/${billingGroupId}/hosts/${hostId}`);

    return data;
  }
}

export const billingGroupApi = new BillingGroupApi();
